import { MpTable } from './Table'
export default MpTable

export { skeletonTable } from './table-skeleton'

export { MpTable, MpTableHeader, MpTableFooter, MpTableRow, MpTableCell, MpTableProps, Column, MpTableColumnsProps, MpTableRowProps, MpTableCellProps } from './Table'
